<template>
  <div class="wrapper">
    <div v-if="moduleCatalog.products.length > 0" class="product-list" v-bind:class="{'product-list--2': view === 2}">
      <catalog-item v-for="item in moduleCatalog.products" :info="item" :key="item.ID"></catalog-item>
    </div>
    <div v-else class="product-list">
      Ничего не найдено
    </div>
    <div v-if="!all" @click="loadMore" class="product-more btn">Загрузить еще</div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import CatalogItem            from "@/components/Catalog/CatalogItem";

export default {
  name       : "CatalogSection",
  components : {CatalogItem},
  props      : {
    pages      : Number,
    view       : Number,
    sort       : Number,
    sort_by    : String,
    sort_order : String,
    section    : Number,
    count      : Number,
    nav_num    : Number,
    filter     : [Array, Object],
    items      : Array
  },
  data()
  {
    return {
      page         : 2,
      all          : false,
      itemQuantity : 0
    };
  },
  computed : {
    ...mapState([
      "moduleCatalog"
    ])
  },
  methods  : {
    ...mapActions([
      "SET_PRODUCTS"
    ]),
    loadMore()
    {
      if(this.all) return;
      let query = (document.location.search === "" ? "?" : "&") + "pagination=Y&PAGEN_" + this.nav_num + "=" + this.page;
      fetch(document.location.href + query, {
        method : "GET"
      })
      .then(response => response.json())
      .then(result =>
      {
        if(result.data.length > 0)
        {
          this.SET_PRODUCTS(result.data);
        }
        this.page++;
        if(this.pages < this.page)
        {
          this.all = true;
        }
      });
    }
  },
  created()
  {
    this.SET_PRODUCTS(this.items);
    this.all = this.pages < this.page;
  }
}
</script>